import * as React from "react";
const SvgSuche = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Suche">
    <path
      fill="currentColor"
      d="m215.71 200.19-57.31-57.31c10.89-13.45 17.11-30.82 16.13-49.65-1.92-36.63-31.33-66.42-67.93-68.77C62.67 21.64 26.32 58 29.14 101.92c2.36 36.66 32.24 66.09 68.93 67.93 18.88.95 36.3-5.35 49.74-16.33l57.28 57.28a7.502 7.502 0 1 0 10.61-10.61Zm-110.12-45.37c-34.85 2.23-63.7-26.62-61.48-61.48 1.84-28.81 25.11-52.08 53.92-53.92 34.85-2.23 63.7 26.62 61.48 61.48-1.84 28.81-25.11 52.08-53.92 53.92"
    />
  </svg>
);
export default SvgSuche;
